import * as React from "react";
import { cn } from "@/lib/utils";

type TooltipSide = "top" | "bottom" | "left" | "right";

export interface TooltipProps {
  content: string;
  side?: TooltipSide;
  children: React.ReactNode;
}

export function Tooltip({ content, side = "bottom", children }: TooltipProps) {
  const id = React.useId();

  const sideClasses: Record<TooltipSide, string> = {
    top: "bottom-full left-1/2 -translate-x-1/2 mb-2",
    bottom: "top-full left-1/2 -translate-x-1/2 mt-2",
    left: "right-full top-1/2 -translate-y-1/2 mr-2",
    right: "left-full top-1/2 -translate-y-1/2 ml-2",
  };

  const arrowClasses: Record<TooltipSide, string> = {
    top: "top-full left-1/2 -translate-x-1/2 border-t-ink",
    bottom: "bottom-full left-1/2 -translate-x-1/2 border-b-ink",
    left: "left-full top-1/2 -translate-y-1/2 border-l-ink",
    right: "right-full top-1/2 -translate-y-1/2 border-r-ink",
  };

  return (
    <span className="tooltip-wrapper group/tooltip relative inline-flex" aria-describedby={id}>
      {children}
      <span
        id={id}
        role="tooltip"
        className={cn(
          "pointer-events-none absolute z-50 w-max max-w-[14rem] rounded-md bg-ink px-2 py-1 text-center text-xs font-medium text-white opacity-0 shadow transition-opacity group-hover/tooltip:opacity-100 group-focus-within/tooltip:opacity-100",
          sideClasses[side]
        )}
      >
        {content}
        <span
          aria-hidden
          className={cn(
            "absolute size-0 border-4 border-transparent",
            arrowClasses[side]
          )}
        />
      </span>
    </span>
  );
}
